import { Button, Card, CardContent, Grid, Paper, Skeleton, Tooltip, Typography } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';

import { useEffect, useState } from 'react';
import { DeleteMapItemComponent } from './delete-map-item.component';

const styling = {
  labelStyle: { paddingBottom: 5, fontWeight: 'bold', fontSize: 16 },
  moveCardStyle: {
    backgroundColor: '#EBEDEF',
    paddingBottom: 15,
    border: '1px solid #D5D8DC',
    borderRadius: 10,
  },
  itemStyle: {
    padding: '8px',
    margin: '5px 0',
    borderRadius: 5,
    border: '1px solid #D5D8DC',
  },
  newItemStyle: {
    padding: '8px',
    margin: '5px 0',
    borderRadius: 5,
    border: '1px solid #3498DB',
  },
};

interface MappingOfficeCell {
  officeData: any;
  onOfficeRemove: (officeID: number, officeName: string, projectCount: number, unitCount: number) => void;
}

export const MappingOfficeCell = ({ officeData, onOfficeRemove }: MappingOfficeCell) => {
  const handleOfficeRemove = () => {
    onOfficeRemove(officeData?.officeID, officeData?.officeName, officeData?.projectCount, officeData?.unitCount);
  };

  return (
    <Paper elevation={0} style={officeData?.isAdded ? styling.newItemStyle : styling.itemStyle}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <Typography variant="h6" style={{ fontSize: 16 }}>
            {officeData?.officeName}
          </Typography>
        </Grid>
        {officeData?.officeMapping && (
          <Grid item>
            {
              officeData?.isAdded ?
                <Button
                  variant="contained"
                  onClick={handleOfficeRemove}
                  disabled={officeData?.isAdded}
                  style={{ minWidth: 1, backgroundColor: '#EAECEE' }}
                >
                  <RemoveIcon />
                </Button>
                :
                <Tooltip title={<Typography variant="body1">Remove</Typography>}>
                  <Button
                    variant="contained"
                    onClick={handleOfficeRemove}
                    style={{ minWidth: 1, backgroundColor: '#ff8a8a' }}
                  >
                    <RemoveIcon />
                  </Button>
                </Tooltip>
            }
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

interface MappingProjectCell {
  projectData: any;
  officeName: string;
  onProjectRemove: (projectID: number, projectName: string, unitCount: number) => void;
}

export const MappingProjectCell = ({ projectData, officeName, onProjectRemove }: MappingProjectCell) => {
  const handleProjectRemove = () => {
    onProjectRemove(projectData?.projectID, projectData?.projectName, projectData?.unitCount);
  };
  return (
    <Paper elevation={0} style={projectData?.isAdded ? styling.newItemStyle : styling.itemStyle}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <Typography variant="h6" style={{ fontSize: 16 }}>
            {projectData?.projectName}
          </Typography>
          <Typography color="text.secondary" variant="body2">
            Office: {officeName}
          </Typography>
        </Grid>
        {projectData?.projectMapping && (
          <Grid item>
            {
              projectData?.isAdded ?
                <Button
                  variant="contained"
                  onClick={handleProjectRemove}
                  disabled={projectData?.isAdded}
                  style={{ minWidth: 1, backgroundColor: '#EAECEE' }}
                >
                  <RemoveIcon />
                </Button>
                :
                <Tooltip title={<Typography variant="body1">Remove</Typography>}>
                  <Button
                    variant="contained"
                    onClick={handleProjectRemove}
                    style={{ minWidth: 1, backgroundColor: '#ff8a8a' }}
                  >
                    <RemoveIcon />
                  </Button>
                </Tooltip>
            }
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

interface MappingUnitCell {
  unitData: any;
  officeName: string;
  projectName: string;
  onUnitRemove: (unitID: number, unitName: string) => void;
}
export const MappingUnitCell = ({ unitData, projectName, officeName, onUnitRemove }: MappingUnitCell) => {
  const handleUnitRemove = () => {
    onUnitRemove(unitData?.unitID, unitData?.unitName);
  };
  return (
    <Paper elevation={0} style={unitData?.isAdded ? styling.newItemStyle : styling.itemStyle}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <Typography variant="h6" style={{ fontSize: 16 }}>
            {unitData?.unitName}
          </Typography>
          <Typography color="text.secondary" variant="body2">
            Office: {officeName}
          </Typography>
          <Typography color="text.secondary" variant="body2">
            Project: {projectName}
          </Typography>
        </Grid>
        {unitData?.unitMapping && (
          <Grid item>
            {
              unitData?.isAdded ?
                <Button
                  variant="contained"
                  onClick={handleUnitRemove}
                  disabled={unitData?.isAdded}
                  style={{ minWidth: 1, backgroundColor: '#EAECEE' }}
                >
                  <RemoveIcon />
                </Button>
                :
                <Tooltip title={<Typography variant="body1">Remove</Typography>}>
                  <Button
                    variant="contained"
                    onClick={handleUnitRemove}
                    style={{ minWidth: 1, backgroundColor: '#ff8a8a' }}
                  >
                    <RemoveIcon />
                  </Button>
                </Tooltip>
            }
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

interface ContactMapListComponent {
  contactID: number;
  customerID: number;
  contactMappedData: any;
  isLoading: boolean;
  isFetching: boolean;
}

export const ContactMapListComponent = ({ contactID, customerID, contactMappedData, isLoading, isFetching }: ContactMapListComponent) => {
  const [removeData, setRemoveData] = useState<any>({
    id: '',
    name: '',
    type: '',
    projectCount: 0,
    unitCount: 0,
  });
  const [alertDialog, setAlertDialog] = useState<any>(false);
  const [mappedData, setMappedData] = useState<any>([]);



  useEffect(() => {
    if (contactMappedData) {
      setMappedData(contactMappedData);
    }
  }, [contactMappedData]);

  // useEffect(() => {
  //   if (newMappedData) {
  //     setMappedData((prevMappedData: any) => {
  //       const updatedMappedData = [...(prevMappedData ?? [])];
  //       let hasChanged = false;

  //       Array.isArray(newMappedData) &&
  //         newMappedData.forEach((newData: any) => {
  //           const officeIndex = updatedMappedData?.findIndex((item) => item.officeID === newData.officeID);

  //           if (officeIndex !== -1) {
  //             const existingData = updatedMappedData[officeIndex];
  //             Array.isArray(newData.contactsProjectMappings) &&
  //               newData.contactsProjectMappings.forEach((newProject: any) => {
  //                 const existingProjectIndex = existingData.contactsProjectMappings.findIndex(
  //                   (project: any) => project.projectID === newProject.projectID
  //                 );

  //                 if (existingProjectIndex !== -1) {
  //                   const existingProjctData = existingData.contactsProjectMappings[existingProjectIndex];
  //                   Array.isArray(newProject.contactsUnitMappings) &&
  //                     newProject.contactsUnitMappings.forEach((newUnit: any) => {
  //                       const existingUnitIndex = existingProjctData.contactsUnitMappings.findIndex(
  //                         (unit: any) => unit.unitID === newUnit.unitID
  //                       );

  //                       if (existingUnitIndex === -1) {
  //                         existingProjctData.contactsUnitMappings.push(newUnit);
  //                         hasChanged = true;
  //                       }
  //                     });
  //                 } else {
  //                   existingData.contactsProjectMappings.push(newProject);
  //                   hasChanged = true;
  //                 }
  //               });
  //             updatedMappedData[officeIndex] = existingData;
  //           } else {
  //             updatedMappedData.push(newData);
  //             hasChanged = true;
  //           }
  //         });

  //       return hasChanged ? updatedMappedData : prevMappedData;
  //     });
  //   }
  // }, [newMappedData]);

  const handleOfficeRemove = (officeID: number, officeName: string, projectCount: number, unitCount: number) => {
    setAlertDialog(true);
    setRemoveData((prevState: any) => ({
      ...prevState,
      id: officeID,
      name: officeName,
      type: 'office',
      projectCount: projectCount,
      unitCount: unitCount,
    }));
  };

  const handleProjectRemove = (projectID: number, projectName: string, unitCount: number) => {
    setAlertDialog(true);
    setRemoveData((prevState: any) => ({
      ...prevState,
      id: projectID,
      name: projectName,
      type: 'project',
      unitCount: unitCount,
    }));
  };

  const handleUnitRemove = (unitID: number, unitName: string) => {
    setAlertDialog(true);
    setRemoveData((prevState: any) => ({
      ...prevState,
      id: unitID,
      name: unitName,
      type: 'unit',
    }));
  };

  const handleClosedDeleteDialog = () => {
    setAlertDialog(false);
    setRemoveData((prevState: any) => ({
      ...prevState,
      id: '',
      name: '',
      type: '',
      projectCount: 0,
      unitCount: 0,
    }));
  };

  return (
    <Card elevation={0} style={{ border: '1px solid #D5D8DC' }}>
      <CardContent>
        {!isLoading || !isFetching ? (
          mappedData?.length > 0 ?
            mappedData?.map((officeMapData: any, index: any) => (
              <Grid container key={`${officeMapData?.officeName}-${officeMapData?.officeID}`}>
                <Grid item xl={12} lg={12} sm={12} xs={12}>
                  <MappingOfficeCell officeData={officeMapData} onOfficeRemove={handleOfficeRemove} />
                  {officeMapData?.contactsProjectMappings?.map((projectMapData: any) => (
                    <Grid
                      key={`${projectMapData?.projectName}-${projectMapData?.projectID}`}
                      container
                      style={{ paddingLeft: '60px' }}
                    >
                      <Grid item xl={12} lg={12} sm={12} xs={12}>
                        <MappingProjectCell
                          projectData={projectMapData}
                          officeName={officeMapData?.officeName}
                          onProjectRemove={handleProjectRemove}
                        />
                        {projectMapData?.contactsUnitMappings?.map((unitMapData: any) => (
                          <Grid
                            key={`${unitMapData?.unitName}-${unitMapData?.unitID}`}
                            container
                            style={{ paddingLeft: '100px' }}
                          >
                            <Grid item xl={12} lg={12} sm={12} xs={12}>
                              <MappingUnitCell
                                unitData={unitMapData}
                                projectName={projectMapData?.projectName}
                                officeName={officeMapData?.officeName}
                                onUnitRemove={handleUnitRemove}
                              />
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            ))
            :
            <div style={{ display: 'flex', justifyContent: 'center', padding: 25 }}>
              <p style={{ textAlign: 'center' }}>
                <b>No data available right now.</b><br />
                Please select a {!customerID ? <><b>Customer</b>,</> : null} <b>Office</b>, <b>Project</b>, and <b>Unit</b> from the above options and click (<b>+</b>) button to Map.
              </p><br />
            </div>
        ) : (
          <>
            <Skeleton variant="rounded" height={40} style={{ marginBottom: 10 }} />
            <Skeleton variant="rounded" height={40} style={{ marginBottom: 10 }} />
            <Skeleton variant="rounded" height={40} />
          </>
        )}
      </CardContent>
      {alertDialog && (
        <DeleteMapItemComponent contactID={contactID} removeData={removeData} onClosed={handleClosedDeleteDialog} />
      )}
    </Card>
  );
};
